import React, { useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ValidationError from "../Errors/ValidationError";
import { VehicleContext } from "../Context/VehicleContext";
// import ReCAPTCHA from 'react-google-recaptcha';
import { useNavigate } from "react-router-dom";
const ReCAPTCHA = React.lazy(() => import("react-google-recaptcha"));
const validationSchema = Yup.object().shape({
    full_name: Yup.string()
        .required('Full Name is required'),
    email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
    phone: Yup.string()
        .required('Phone number is required'),
    comments: Yup.string()
        .max(500, 'Comments cannot exceed 500 characters')
});

const ContactForm = () => {
    const navigate = useNavigate();
  const { submitContactForm } = useContext(VehicleContext);
  const recaptchaRef = React.useRef();

  return (
    <Formik
      initialValues={{
        full_name: '',
        email: '',
        phone: '',
        comment: '',
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm }) => {
        const token = await recaptchaRef.current.executeAsync();
        recaptchaRef.current.reset(); // Reset after use

        values.token = token;

        console.log(values);
        const data = await submitContactForm(values);

        if (data.success) {
          resetForm();
          // alert("Thank you for your submission. We'll be in touch soon!");
          navigate("/thank-you");
        } else
          alert("There was a problem with your submission");
      }}
    >
      {({ handleSubmit }) => (
        <Form className="custom-form contact-form" autoComplete="off" name="contact-form" onSubmit={handleSubmit} >
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6LfCa-srAAAAADUg9n4Myr1K_n2iOzduQAO6ZffA" // Replace with your actual site key
            size="invisible"
          />
            <div className='form-group'>
                <div className='cs-label'>Full Name <span className='text-danger font-15'>*</span></div>
              <Field
                type="text"
                name="full_name"
                className="form-control"
                required />
              <ValidationError name="full_name" />
            </div>
            <div className='form-group'>
                <div className='cs-label'>Email <span className='text-danger font-15'>*</span></div>
              <Field
                type="text"
                name="email"
                className="form-control"
                required />
              <ValidationError name="email" />
            </div>
            <div className='form-group'>
                <div className='cs-label'>Phone Number <span className='text-danger font-15'>*</span></div>
              <Field
                type="text"
                name="phone"
                className="form-control"
                required />
              <ValidationError name="phone" />

            </div>
            <div className='form-group mb-28'>
              <div className='cs-label'>Comments</div>
              <Field
                type="text"
                name="comment"
                className="form-control"
                component="textarea" />
              <ValidationError name="comment" />
            </div>
            <div>
              <button type='submit' className='black-btn get-started-btn fw-700 text-uppercase w-100 d-inline-block lg-btn font-1-2em'>Submit</button>
            </div>
        </Form>
      )}
    </Formik>
  );
};

export default ContactForm;
